module.exports = __webpack_public_path__ + "img/Derbey.f4ed81dd.jpeg";